/** @format */

import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconMediaPause,
	homefieldIconMediaPlay
} from '@dsg-tech/homefield-angular-icons';

import { CarouselComponent } from './carousel.component';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StoryModule } from '../story/story.module';

@NgModule({
	imports: [CommonModule, HomefieldIconLibraryModule, NgbModule, StoryModule],
	declarations: [CarouselComponent],
	exports: [CarouselComponent],
	schemas: [NO_ERRORS_SCHEMA]
})
export class CarouselModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconMediaPlay,
			homefieldIconMediaPause
		]);
	}
}
